import React from 'react'
import classes from "./Textarea.module.css"
import clsx from "clsx"
const Textarea = ({label,id,isOptional,value,onChange,placeholder,errorText,...rest}) => {
  return (
    <div className={classes.wrapper}>
        <label htmlFor={`textarea-${id || label}`} className={classes.labelText}>
            {label} {!isOptional && <span className={clsx("steric")}>*</span>}
        </label>
        <textarea className={classes.textarea} value={value} onChange={(e)=>onChange(e.target.value)} placeholder={placeholder} {...rest}></textarea>
        {errorText && <span className={classes.errorText}>{errorText}</span>}
    </div>
  )
}

export default Textarea